import IntroPage from './IntroPage';
import LoadingPage from './LoadingPage';
import GamePage from './GamePage';

export { IntroPage, LoadingPage, GamePage };
